import styled from 'styled-components';

export const Wrapper = styled.ul`
  display: flex;
  gap: var(--spacing-s);
  margin-bottom: var(--spacing-m);
  overflow-x: auto;
`;
